import { forEach } from 'lodash';

export const updateColorPercent = (color, percent = 10) => {
  const f = parseInt(color, 16);
  const t = percent < 0 ? 0 : 255;
  const p = percent < 0 ? percent * -1 : percent;
  const R = f >> 16; // eslint-disable-line
  const G = (f >> 8) & 0x00ff; // eslint-disable-line
  const B = f & 0x0000ff; // eslint-disable-line
  return `#${(
    0x1000000 +
    (Math.round((t - R) * p) + R) * 0x10000 +
    (Math.round((t - G) * p) + G) * 0x100 +
    (Math.round((t - B) * p) + B)
  )
    .toString(16)
    .slice(1)}`;
};

export const overrideBrandUI = (
  surveyTheme,
  hasAdvancedThemeColors = false,
) => {
  const {
    logoUrl,
    headerBackgroundColor = 'rgba(255,255,255,1)',
    progressBarEnabled = true,
    progressBarColor = 'rgba(46,105,240,1)',
    progressBarBackgroundColor = 'rgba(232,235,239,1)',
    questionsColor = 'rgba(51,57,68,1)',
    promptBoxColor = 'rgba(255,255,255,1)',
    promptBoxBackgroundColor = 'rgba(251,59,113,1)',
    answerTextColor = 'rgba(51,57,68,1)',
    answerTextColorSecondary = 'rgba(51,57,68,1)',
    answerUiColorSelected = 'rgba(46,105,240,1)',
    answerUiColor = 'rgba(232,235,239,1)',
    answerBackgroundColor = 'rgba(255,255,255,1)',
    answerBackgroundColorSelected = 'rgba(255,255,255,0.7)',
    buttonColor = 'rgba(46,105,240,1)',
    buttonColorIcon = 'rgba(255,255,255,1)',
    backgroundColor = 'rgba(249,250,252,1)',
    containerBackgroundColor = 'rgba(10,10,10,1)',
    containerTextColor = 'rgba(255,255,255,1)',
    containerBorderColor = 'rgba(92, 103, 118, 1)',
  } = surveyTheme;

  const headerLogoEl = document.querySelector('.header__logo');
  const isLogoSvg = logoUrl && logoUrl.indexOf('.svg') > 0;

  if (logoUrl) {
    const headerLogo = document.createElement('img');
    if (headerLogoEl) {
      headerLogo.src = logoUrl;
      headerLogo.className = 'header-logo-custom';
      $(headerLogoEl).empty();
      headerLogoEl.appendChild(headerLogo);
    }
  } else {
    const pollfishLogo = document.createElement('span');
    pollfishLogo.className = 'icon-Prodege_Pollfish';
    if (headerLogoEl) {
      $(headerLogoEl).empty();
      headerLogoEl.appendChild(pollfishLogo);
    }
  }

  const primaryColor = '#323945';

  const backgroundInverted = Pollfish.helper.getTextColor(
    backgroundColor,
    false,
  );

  const rankingOpacity = backgroundInverted === '#000000' ? '0.3' : '0.7';

  Pollfish.ui.removeBrandedTheme();

  // grab either white or black based on given color
  // const invertedColor = Pollfish.helper.getTextColor(primaryColor);
  $('head').append(`
          <style id="branded-theme" data-theme="true">
          
         .header__container {
          background-color: transparent!important;
         }
          
         .header, .question-wrapper {
            background-color: ${headerBackgroundColor}!important;
          }
            
            .header-logo-custom {
              width: auto;
              height: auto;
              max-width: 80px;
              max-height: 46px;
              ${isLogoSvg ? 'min-height: 46px;' : ''}
            }
            
            .qp-bar {
              visibility: ${progressBarEnabled ? 'visible' : 'hidden'};
            }
          
            .color-primary {
              color: ${primaryColor} !important;
            }
            
            .question__prompt-wrapper {
             background-color: ${promptBoxBackgroundColor}!important;
            }
            
            .question__prompt-wrapper .question__prompt {
              color: ${promptBoxColor}!important;
            }

            .btn-primary,
            .btn-w-icon {
              color: ${buttonColorIcon};
              background-color: ${buttonColor} !important;
            }
            
            .btn-primary:active, .btn-primary:focus, .btn-primary:hover,
            .btn-w-icon:active, .btn-w-icon:focus, .btn-w-icon:hover {
              color: ${buttonColorIcon};
              background-color: ${buttonColor} !important;
            }
            
            .prompt-info__text {
              background-color: ${promptBoxBackgroundColor};
              color: ${promptBoxColor};
            }
            
            .answer, .matrix__answer, .input-text, .text-area {
              color: ${answerTextColor};
              background-color: ${answerBackgroundColor};
              border-color: transparent;
            }
            
            .answer::placeholder, .matrix__answer::placeholder, .input-text::placeholder, .text-area::placeholder {
              color: ${answerTextColor};
              opacity: 0.8;
            }
            
            .loading__header p, p[data-testid="earned_reward"] {
              ${hasAdvancedThemeColors ? `color: ${containerTextColor}` : ''};
            }
            
            #rating-container p {
              ${hasAdvancedThemeColors ? `color: ${containerTextColor}` : ''};
            }
            
            .countdown__title {
              ${hasAdvancedThemeColors ? `color: ${containerTextColor}` : ''};
            }
            
            .homescreen-card {
              ${
                hasAdvancedThemeColors
                  ? `background-color: ${containerBackgroundColor}`
                  : ''
              };
              ${
                hasAdvancedThemeColors
                  ? `border-color: ${containerBorderColor}`
                  : ''
              };
            }
            
            .homescreen-card #js-offer-rewards p {
              ${
                hasAdvancedThemeColors
                  ? `color: ${containerTextColor}!important`
                  : ''
              };
            }
            
            .answer.answerClick .answer__description,
            .answerClick.matrix__answer .answer__description,
            .answer--click .answer__description,
            .answer.answerClick:not(.answer--with-image),
            .answerClick.matrix__answer:not(.answer--with-image),
            .answer--click:not(.answer--with-image) {
              color: ${answerUiColorSelected};
              background-color: ${answerBackgroundColorSelected};
              /*background-color: #ffffffe6;*/
            }
            
            .answer--with-image .answer__description {
              color: ${answerTextColor};
              background-color: ${answerBackgroundColor};
            }
            
            .input-text, .text-area {
              border-color: ${answerUiColorSelected};
            }
            
            #otherContainer .input-text {
              border-color: white;
            }
            
            .header__action-close-btn,
            .header__action-close-btn:active, 
            .header__action-close-btn:focus, 
            .header__action-close-btn:hover {
              color: ${backgroundInverted}!important;
            }
            
            .header__action-move-back-btn:after {
              color: ${backgroundInverted}!important;
            }
            
            .header__action-refresh-btn {
              background-color: rgba(255,255,255, 0.9);
              border-radius: 4px;
            }

            .answer.answer--with-image,
            .answer--with-image.matrix__answer,
            .answer--with-image {
              border-color: ${answerUiColor};
            }
            
            .answer.answer--with-image.answerClick,
            .answer--with-image.answerClick.matrix__answer,
            .answer--click.answer--with-image {
              border-color: ${answerUiColorSelected};
            }

            .answer .answer__description .answer__description:before,
            .matrix__answer .answer__description .answer__description:before,
            .matrix__answer .answer__description:before,
            .answer:not(.answer--with-image) .answer__description:before,
            .matrix__answer:not(.answer--with-image) .answer__description:before,
            .answer:not(.answer--with-image):before,
            .matrix__answer:not(.answer--with-image):before,
            .answer:not(.answer--with-image) .answer__description:before,
            .answer:not(.answer--with-image):before,
            .answer .answer__description:before,
             .answer .answer__description .answer__description:before,
            .answer .answer__description:before {
              color: ${answerUiColor};
            }
            
            .answer.answerClick .answer__description .answer__description:before,
            .answerClick.matrix__answer .answer__description .answer__description:before,
            .answerClick.matrix__answer .answer__description:before,
            .answer.answerClick:not(.answer--with-image) .answer__description:before,
            .answerClick.matrix__answer:not(.answer--with-image) .answer__description:before,
            .answer.answerClick:not(.answer--with-image):before,
            .answerClick.matrix__answer:not(.answer--with-image):before,
            .answer--click:not(.answer--with-image) .answer__description:before,
            .answer--click:not(.answer--with-image):before,
            .answer.answerClick .answer__description:before,
             .answer--click .answer__description .answer__description:before,
            .answer--click .answer__description:before,
            .matrix__selected-answer {
              color: ${answerUiColorSelected};
            }
            
            
            .answer.answer--max-diff {
              overflow: hidden;
              background-color: #E8EBEF!important;
            }
            
            .answer.answer--max-diff  .answer-concept-wrapper {
              background-color: ${answerBackgroundColor}!important;
              color: ${answerTextColor}!important;
            }

            #qp-bar-number {
              color: ${progressBarColor};
            }

            .qp-bar__line {
              background-color: ${progressBarBackgroundColor};
            }
            
            .qp-bar__line #progressBar {
              background-color: ${progressBarColor};
            }

            #wrapper {
              background-color: ${backgroundColor};
            }
            
            [data-page=homescreen-non-incentive] #wrapper, [data-page=homescreen-incentive] #wrapper, [data-page=loading] #wrapper, [data-page=no-survey-available--offerwall] #wrapper, [data-page=thank-you] #wrapper, [data-page=wait-screen] #wrapper {
              background-color: ${
                hasAdvancedThemeColors
                  ? containerBackgroundColor
                  : '#f9fafc!important'
              };
              ${hasAdvancedThemeColors ? `color: ${containerTextColor}` : ''}
            }

            [data-page="terms"] #wrapper {
              ${
                hasAdvancedThemeColors
                  ? `background-color: ${containerBackgroundColor}`
                  : 'background-color: #f9fafc'
              }; 
            }
            
            [data-page="terms"] #wrapper {
              ${hasAdvancedThemeColors ? `color: ${containerTextColor}` : ''}; 
            }
            
            [data-page="terms"] #wrapper p {
              ${hasAdvancedThemeColors ? `color: ${containerTextColor}` : ''}; 
              ${hasAdvancedThemeColors ? `opacity: 0.7` : ''}; 
            }
            
            [data-page="gdpr"] #wrapper {
              ${
                hasAdvancedThemeColors
                  ? `background-color: ${containerBackgroundColor}`
                  : 'background-color: #f9fafc'
              }; 
              ${hasAdvancedThemeColors ? `color: ${containerTextColor}` : ''}; 
            }
            
            [data-page="gdpr"] #wrapper * {
              ${hasAdvancedThemeColors ? `color: ${containerTextColor}` : ''}; 
            }
            
            [data-page="gdpr"] #wrapper button {
              ${hasAdvancedThemeColors ? `color: #0e68f9` : ''}; 
            }
            
            .js-survey-reject-btn {
              ${hasAdvancedThemeColors ? `color: ${containerTextColor}` : ''};
            }
            
            .footer__terms {
              ${
                hasAdvancedThemeColors
                  ? `color: ${containerTextColor}!important`
                  : ''
              };
            }
            
            
            .terms-and-conditions__footer {
              ${
                hasAdvancedThemeColors
                  ? `background-color: ${containerBackgroundColor}`
                  : ''
              };
              
            }
            
            .text-lighter, .text-light {
              ${hasAdvancedThemeColors ? `color: ${containerTextColor}` : ''};
            }
            
            .question__text {
              color: ${questionsColor}!important;
            }

            .ui-btn-inner .ui-btn-text:before,
            .ui-btn-inner .ui-btn-text:after {
              color: ${answerUiColorSelected};
            }
            
            .ui-slider-track {
              background-color: ${answerUiColor} !important;
            }
            
            .ui-btn-active {
              background-color: ${answerUiColorSelected};
            }
            
            .bipolar-slider-row-label {
              color: ${backgroundInverted};
            }
            
            .bipolar-vertical:after {
              color: ${answerTextColor};
            }
            
            .ranking__answer-btn--selected {
              background-color: ${answerBackgroundColorSelected} !important;
              color: ${answerUiColorSelected}!important;
              border-color: ${answerUiColorSelected}!important;
            }
            
            .ui-btn-inner {
              border-color: ${answerUiColorSelected} !important;
            }
            
            .answer--matrix-open-ended-row-label {
              color: ${answerTextColor};
            }
            
            .answer--matrix-open-ended-column-required {
              color: ${answerTextColorSecondary};
            }


            .bipolar-horizontal-column:before,
            .bipolar-vertical-column:before,
             .bipolar-horizontal-column,
            .bipolar-vertical-column {
              color: ${answerUiColor};
            }
            
            .bipolar-horizontal-column.column-selected:before,
            .bipolar-vertical-column.column-selected:before {
              color: ${answerUiColorSelected};
            }

            .bipolar-vertical--checked:before {
              color: ${answerUiColorSelected};
            }
            
            .bipolar-vertical-row-label {
              color: ${answerTextColor};
            }

            .bipolar-slider-step{
              border-color: ${answerUiColorSelected};
            }
            
            .bipolar-slider .ui-slider-handle {
              background-color: ${answerUiColorSelected};
              border-color: ${answerUiColorSelected};
            }
            
            .bipolar-slider .ui-slider-handle--touched {
              background-color: ${answerUiColorSelected};
            }
            .bipolar-slider .ui-slider-bg,
            .bipolar-slider .ui-slider-track {
              background-color: #E1E6EC !important;
            }
            
            .answer--matrix-open-ended-column-label {
              color: ${answerTextColorSecondary};
            }
            
            .bipolar-horizontal-row-labels {
              color: ${answerTextColor};
            }
            
            .bipolar-horizontal-label {
              color: ${answerTextColorSecondary};
            }
            
            .ab-attribute-label {
              color: ${answerTextColor};
            }

            .scrollbox {
              background-image:
                /* Shadows */
                linear-gradient(to right, ${backgroundColor}, ${backgroundColor}),
                linear-gradient(to right, ${backgroundColor}, ${backgroundColor}),
                /* Shadow covers */
                linear-gradient(to right, rgba(0,0,0,.1), rgba(255,255,255,0)),
                linear-gradient(to left, rgba(0,0,0,.1), rgba(255,255,255,0));
            }
            
            .header__action-language-select .select__container {
              background-color: rgba(255,255,255,0.9)!important;
            }
            
          .answer--matrix-open-ended-answer-input[type=number], .answer--matrix-open-ended-answer-input-container {
            background-color: ${answerBackgroundColor};
            color: ${answerTextColor};
          }
          
          .answer--matrix-open-ended-info-message {
            color: ${primaryColor};
          }
          
          .answer--matrix-open-ended-info-message > span {
            background-color: rgba(255,255,255,0.9);
            padding: 4px 7px;
            border-radius: 50px;
          }
          
          .input-text-note {
            margin-top: 2px;
          }
          
          .input-text-note > span {
            background-color: rgba(255,255,255,0.9);
            padding: 4px 7px;
            border-radius: 50px;
          }
          
          .dropdown-select .dropdown-select-header {
            color: ${answerTextColorSecondary};
          }
          
          .dropdown-select .dropdown-select-toggle {
            background-color: ${answerBackgroundColorSelected};
            color: ${answerUiColorSelected};
            border-radius: 4px;
          }
          
          .dropdown-select.disabled .dropdown-select-toggle {
            background-color: ${answerBackgroundColor};
            /*opacity: 0.7;*/
          }
          
          .dropdown-select-search-container {
            background-color: ${answerBackgroundColor};
          }
          
          .dropdown-select-list {
            -webkit-box-shadow: none;
            box-shadow: none;
          }
          
          .dropdown-select-list-item {
            background-color: ${answerBackgroundColor};
          }
          
          .dropdown-select .dropdown-select-list-item button {
            color: ${answerTextColor};
          }
          
          .dropdown-select .dropdown-select-list-item:hover {
            opacity: 0.9;
          }
          
          .dropdown-select .dropdown-select-list-item:hover button {
            background-color: ${answerBackgroundColor};
            color: ${answerTextColor};
          }
          
          .dropdown-select .no-results-container {
            background-color: ${answerBackgroundColor};
            color: ${answerTextColor};
          }

          .ranking__answer-btn {
            background-color: ${answerBackgroundColor};
            color: ${answerTextColor};
            /*border-color: transparent;*/
          }

          .matrix:before {
            color: ${backgroundInverted};
          }
          
          .answer-attribute-text {
            color: ${answerTextColor};
          }
          
          .answerClick .answer-attribute-text, .answerClick .answer-attribute-label {
            color: ${answerUiColorSelected};
          }
          
          .answer-attribute-label {
            color: ${answerTextColor};
          }
          
          
          .matrix__question,
          .answers-wrapper--description,
          .scale-step,
          .scale-step.closer,
          .scale-step.close,
          .scale-step.sticky,
          .ranking__answers-high,
          .ranking__answers-low,
          .ranking__title {
            color: ${answerTextColor};            
          }
          
          .ranking__answers-high,
          .ranking__answers-low {
            color: ${answerTextColorSecondary};            
          }
          
          .scale-label,
          .scale-step.sticky {
            color: ${answerTextColorSecondary};            
          }
          
          .scale-label.active,
          .scale-step.active,
          .ui-slider-value {
            color: ${answerUiColorSelected}!important;
          }

          .scale-step {
            color: ${answerUiColor}!important;
          }
          
          .scale-step.closer,
          .scale-step.close,
          .scale-step.active {
            color: ${answerUiColorSelected}!important;
          }
          
          .rating-stars__symbol.icon-star-o {
            color: ${answerUiColor};
          }
          
          .rating-stars__symbol.icon-star.icon-star-o {
            color: ${answerUiColorSelected};
          }
          
          
          .ranking__answer-btn--disabled {
            opacity: ${rankingOpacity};
            border-color: transparent;
          }
          .matrix__hide-answers-btn {
            color: ${answerTextColor};
            border-color: ${answerTextColor} !important;
          }
          
          .matrix__hide-answers-btn:active, .matrix__hide-answers-btn:focus, .matrix__hide-answers-btn:hover {
            color: ${answerTextColor};
          }
          
          .answer--matrix-open-ended-row-total > span {
            background-color: rgba(255,255,255,0.9);
            padding: 4px 7px;
            border-radius: 50px;
          }

          .unlock-screen--title h1,
          .unlock-screen--title p,
          .unlock-screen--acceptance-info,
          .footer__terms {
            color: ${primaryColor};
          }

          [data-page="gdpr"] h1,
          [data-page="gdpr"] h2,
          [data-page="gdpr"] p,
          [data-page="gdpr"] li {
            color: ${primaryColor};
          }

          .gdpr-footer--outer .gdpr-btn-container h1 {
            color: unset;
          }

          .points-container h1 {
            color: ${primaryColor}
          }
          
          .loading__header--short {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          
          .loading__header--short + .loading__image-container {
            display: none;
          }

          </style>
        `);
};

function decodeUriCustom(query) {
  const ret = {};
  function splitOnFirst(string, separator) {
    if (!(typeof string === 'string' && typeof separator === 'string')) {
      throw new TypeError('Expected the arguments to be of type `string`');
    }

    if (string === '' || separator === '') {
      return [];
    }

    const separatorIndex = string.indexOf(separator);

    if (separatorIndex === -1) {
      return [];
    }

    return [
      string.slice(0, separatorIndex),
      string.slice(separatorIndex + separator.length),
    ];
  }

  const formatter = (key, value, accumulator) => {
    if (accumulator[key] === undefined) {
      accumulator[key] = value;
      return;
    }

    accumulator[key] = [].concat(accumulator[key], value);
  };

  const queryParams = query.split('&');
  queryParams.map((param) => {
    if (param !== '') {
      const [key, valueTemp] = splitOnFirst(param, '=');
      let value = valueTemp;

      // Missing `=` should be `null`:
      // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
      value = value === undefined ? null : value;
      formatter(key, decodeURIComponent(value), ret);
    }
    return null;
  });

  const retKeys = Object.keys(ret);
  retKeys.map((key) => {
    const value = ret[key];
    if (typeof value !== 'object' || value === null) {
      ret[key] = value;
    }
    return null;
  });

  return ret;
}

export const getBrandedSurveyFromParams = () => {
  const colorProps = [
    'logoUrl',
    'headerBackgroundColor',
    'progressBarEnabled',
    'progressBarColor',
    'progressBarBackgroundColor',
    'questionsColor',
    'promptBoxColor',
    'promptBoxBackgroundColor',
    'buttonColor',
    'buttonColorIcon',
    'backgroundColor',
    'answerTextColor',
    'answerTextColorSecondary',
    'answerUiColor',
    'answerUiColorSelected',
    'answerBackgroundColor',
    'answerBackgroundColorSelected',
  ];

  const isBoolean = (key) => key === 'progressBarEnabled';

  const surveyTheme = {};

  const urlParams = decodeUriCustom(window.location.search);

  forEach(colorProps, (prop) => {
    let currentPropValue = urlParams[prop];
    if (currentPropValue === 'null') {
      currentPropValue = undefined;
    } else if (isBoolean(prop)) {
      if (currentPropValue === 'false') {
        currentPropValue = false;
      }
      if (currentPropValue === 'true') {
        currentPropValue = true;
      }
    }
    surveyTheme[prop] = currentPropValue;
  });

  return surveyTheme;
};
